import { render, staticRenderFns } from "./ProductDetailModal.vue?vue&type=template&id=73d35b6f&scoped=true&"
import script from "./ProductDetailModal.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailModal.vue?vue&type=style&index=0&id=73d35b6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d35b6f",
  null
  
)

export default component.exports